module.exports = __webpack_public_path__ + "img/ContactUs-o.21e96951.svg";